import PageBreadcrumb from "../components/common/PageBreadCrumb";
import PageMeta from "../components/common/PageMeta";
import ColorGrid from "../components/tables/ColorGrid";

export default function ColorPage() {
    return (
        <>
            <PageMeta
                title="Color Management | Shoplattice Admin Dashboard"
                description="Manage Storefront Colors"
            />
            <PageBreadcrumb pageTitle="Theme Management" />
            <div className="space-y-6">
                <ColorGrid />
            </div>
        </>
    );
}
